export default "__VITE_ASSET__OUKDLORe__"